import {Component, OnInit} from '@angular/core';
import {CreateStoreService} from "@app/features/store-invitation/create-store.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "@shared/services/toast.service";
import {AuthService} from "@app/core/services/auth.service";
import { NavigationService } from '@app/shared/services/navigation-service.service';

export enum STORE_ACTION_ENUM {
  next = 'next',
  back = 'back',
}

export class CREATE_STORE_FORM_ACTION {
  action?: STORE_ACTION_ENUM;
  selectedIndex: number = 0;
  data?: any;

}

@Component({
  selector: 'app-create-store',
  templateUrl: './create-store.component.html',
  styleUrls: ['./create-store.component.scss']
})

export class CreateStoreComponent implements OnInit {
  public selectedPage: number = 1;
  public progress = 25;
  public store = {
    storeName: "",
    password: "",
    description: "",
    storeLogoImageUrl: "",
    storeCategory: {
      name: '',
      description: '',
      id: '',
      createdDate: "2022-12-26T15:29:17.339+0200",
      updatedDate: "2022-12-26T15:29:17.340+0200"
    },
    location: {
      name: "Ramallah Street",
      latitude: 31.0,
      longitude: 35.0,
      createdDate: "2022-12-26T15:27:46.174+0200",
      updatedDate: "2022-12-26T15:27:46.174+0200",
      country: {
        name: '',
        countryCode: '',
        id: '',
        createdDate: "2022-08-21T22:09:54.000+0300",
        updatedDate: "2022-08-21T22:09:54.000+0300"
      },
    },
    device: {
      UDID: "0603798b-ce7f-4d8e-89dc-101e99203bd6",
      notificationsToken: "1231233211313",
      operatingSystem: "OTHER",
      userAgent: "Lychee Web"
    },
    clientType: "WEB"
  }
  public id: string | null | undefined;
  public token: any;
  private pageReloaded: boolean = false;

  constructor(public storeService: CreateStoreService,
              private route: ActivatedRoute,
              private toast: ToastService,
              private authService: AuthService,
              private spinner: NgxSpinnerService,
              public router: Router,
              public navigation: NavigationService) {
                this.authService.removeLocalStorageItemsWithoutLogin();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    // The secret from the e-mailed link: the API refuses the invitation without it.
    this.token = this.route.snapshot.queryParamMap.get('token');
  }

  public next(): void {
    ++this.selectedPage;
    this.progress = this.progress + 25;
  }

  public back(): void {
    --this.selectedPage;
    this.progress = this.progress - 25;
  }

  public createStore() {
    this.spinner.show();
    this.storeService.createStore(this.id ?? '', {...this.store, invitationToken: this.token}).subscribe((res: any) => {
      const twoHoursInSeconds = 2 * 60 * 60;
      this.authService.setCreateInvitation(res.accessToken, res.userId, res.store, {value : res.store?.countryCode, expiry: twoHoursInSeconds});
      this.router.navigate(['/dashboard', { fromCreateStore: true }]);
      this.spinner.hide();
      },
      error => {
        this.spinner.hide()
        console.log(error);
        // e.g. "This invitation link is not valid or has expired..." from the API.
        const message = error && error.error && (error.error.error || error.error.message);
        if (message) {
          this.toast.error(message);
        }
      })
  }

  public handelAction(event: CREATE_STORE_FORM_ACTION): void {
    if (event.action == STORE_ACTION_ENUM.next) {
      if (event.selectedIndex === 1) {
        this.store = {...this.store, storeName: event.data.name, password: event.data.password}
        this.next();
      } else if (event.selectedIndex === 2) {
        this.store = {...this.store, description: event.data.description}
        this.next();
      } else if (event.selectedIndex === 3) {
        this.store = {
          ...this.store,
          storeCategory: {...this.store.storeCategory, id: event.data.cat},
          storeLogoImageUrl: event.data.logo
        }
        this.next();
      } else if (event.selectedIndex === 4) {
        this.store = {
          ...this.store,
          location: {
            ...this.store.location,
            country: event?.data?.country,
            longitude: event.data.longitude,
            latitude: event.data.latitude,
            name: event.data.name
          }
        };
        this.createStore();
      }
    } else if (event.action == STORE_ACTION_ENUM.back) {
      if (event.selectedIndex === 3) {
        this.store = {
          ...this.store,
          storeCategory: {...this.store.storeCategory, id: event.data.cat},
          storeLogoImageUrl: event.data.logo
        }
      } else if (event.selectedIndex === 4) {
        this.store = {
          ...this.store,
          location: {
            ...this.store.location,
            country: event?.data?.country,
            longitude: event.data.longitude,
            latitude: event.data.latitude
          }
        };
      }
      this.back();
    }
  }
}
